/**
 * @generated SignedSource<<6d4835771c784f586126c343d3a69ce8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PersonRequestDeleteMutation$variables = {
  id: number;
};
export type PersonRequestDeleteMutation$data = {
  readonly deletePersonRequest: {
    readonly account: {
      readonly id: number;
      readonly person_requests: ReadonlyArray<{
        readonly id: number;
      }>;
    } | null | undefined;
    readonly id: number;
    readonly person: {
      readonly id: number;
      readonly person_requests: ReadonlyArray<{
        readonly id: number;
      }>;
    } | null | undefined;
  };
};
export type PersonRequestDeleteMutation = {
  response: PersonRequestDeleteMutation$data;
  variables: PersonRequestDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "person_requests",
    "kind": "LinkedField",
    "name": "person_requests",
    "plural": true,
    "selections": [
      (v1/*: any*/)
    ],
    "storageKey": null
  }
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "DeletePersonRequest",
    "kind": "LinkedField",
    "name": "deletePersonRequest",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "accounts",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": (v2/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "people",
        "kind": "LinkedField",
        "name": "person",
        "plural": false,
        "selections": (v2/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PersonRequestDeleteMutation",
    "selections": (v3/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PersonRequestDeleteMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "e8bd35fb6fe72ddedb0f193a01ed6126",
    "id": null,
    "metadata": {},
    "name": "PersonRequestDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation PersonRequestDeleteMutation(\n  $id: Int!\n) {\n  deletePersonRequest(id: $id) {\n    id\n    account {\n      id\n      person_requests {\n        id\n      }\n    }\n    person {\n      id\n      person_requests {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "70dd81683a96bfeceed0cc807e1ee827";

export default node;
